import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PeopleGroup3Outlined } from "@common-packages/react-icons";
import { isBefore, startOfDay } from "date-fns";
import { useTranslation } from "react-i18next";
import Widget from "@components/Widget/Widget";
import { useDatePickerContext } from "@contexts/DatePickerContext";
import { PaxPredictionGraph } from "../components/PaxPredictionGraph";
export const PaxPredictionGraphWidget = () => {
    const { t } = useTranslation();
    const { picker: { from }, } = useDatePickerContext();
    const datePickerIsBeforeToday = isBefore(from, startOfDay(new Date()));
    return (_jsxs(Widget.Container, { children: [_jsx(Widget.Header, { title: datePickerIsBeforeToday ? t("pax.widgets.paxHistory.title") : t("pax.widgets.paxPredictions.title"), subtitle: datePickerIsBeforeToday
                    ? t("pax.widgets.paxHistory.subTitle")
                    : t("pax.widgets.paxPredictions.subTitle"), icon: {
                    component: (_jsx(PeopleGroup3Outlined, { width: "1.5rem", height: "1.5rem" })),
                } }), _jsx(Widget.Body, { children: _jsx(PaxPredictionGraph, {}) })] }));
};
PaxPredictionGraphWidget.displayName = "PaxPredictionGraphWidget";
